import React from 'react'
import InternFrame from 'components/InternFrame'
import Colors from 'utils/Colors'

import Container from './styles'

function BuildScoreData(props) {
  const { score } = props

  const getColor = (scorePoints) => {
    if (!scorePoints) {
      return 'inherit'
    }

    if (scorePoints <= 400) {
      return Colors.red
    }

    if (scorePoints < 700) {
      return Colors.orange
    }
  
    return Colors.green
  }

  return (
    <InternFrame title="Pontuação de score de risco" color={getColor(score)}>
      <Container>
        <span>Pontuação: </span>
        {score || 'N/A'}
      </Container>
    </InternFrame>
  )
}

export default BuildScoreData
